import { defineMessages } from 'react-intl';

const messages = defineMessages({
  header: {
    description: 'International settings header',
    defaultMessage: 'International Settings',
    id: 'nTEt+W',
  },
  customs: {
    description: 'International settings customs subheader',
    defaultMessage: 'Default Customs Information',
    id: 'zokJDo',
  },
  tracking: {
    description: 'International settings Tracking subheader',
    defaultMessage: 'Tracking',
    id: '+3dqKX',
  },
  pageDescription: {
    description: 'International settings page description',
    defaultMessage:
      'ShipStation can automatically assign a default setting for your customs information for every order that is imported with an international destination. You can always change this setting on individual orders as well.',
    id: '/hqkPW',
  },
  itnTaxNote: {
    description: 'Note for ITN tax ID selection',
    defaultMessage:
      '<b>Note:</b> This setting will apply to USPS, FedEx, UPS and international shipments containing commercial invoices. Your Tax ID will be encrypted and will not display in the ShipStation interface.',
    id: 'JdmgK9',
  },
  defaultUSPSExepmtionCodeNote: {
    description: 'International settings USPS default exepmtion code note',
    defaultMessage:
      '<b>Note:</b> This setting will apply to USPS shipments only. For more information about these AES Exemption Codes, click <a>here</a>.',
    id: 'gBu5Ep',
  },
  vatNote: {
    description: 'International settings VAT note',
    defaultMessage: '<b>Note</b>: Your VAT Registration Number will be applied to your Commercial Invoices for international shipments.',
    id: 'niRzFz',
  },
  encrypted: {
    description: 'International settings ITN encrypted placeholder',
    defaultMessage: '(Encrypted)',
    id: 'hHf36r',
  },
  nonTrackableHover: {
    description: 'Hovertext for non-trackable checkbox',
    defaultMessage:
      'Some international shipments do not provide valid tracking numbers; however, you can opt out using the labels\' "reference number" as a tracking number. This is generally recommended only for marketplaces that require a tracking number for every shipment.',
    id: 'MZo+EL',
  },
  taxIdentifiers: {
    description: 'Tax identifier section heading',
    defaultMessage: 'Tax Identifiers',
    id: 'e+EkhQ',
  },
  addAnotherTaxIdentifier: {
    description: 'Tax identifier add another tax id',
    defaultMessage: 'Add Another Tax Identifier',
    id: 'lREad4',
  },
  addATaxIdentifier: {
    description: 'Tax identifier add another tax id',
    defaultMessage: 'Add a Tax Identifier',
    id: 'EkClL0',
  },
  addTaxIdentifierButton: {
    description: 'Tax identifier add another tax id',
    defaultMessage: 'Add Tax Identifier',
    id: 'PphPxt',
  },
  addTaxIdentifier: {
    description: 'Tax identifier empty description',
    defaultMessage: 'Add a tax identifier such as TIN, SSN, EIN, VAT, or EORI for international orders.',
    id: 'AefATY',
  },
  optional: {
    description: 'Optional Tax identifier field',
    defaultMessage: '(Optional)',
    id: 'y7xYty',
  },
  delete: {
    description: 'Delete Tax identifier row',
    defaultMessage: 'Delete',
    id: 'scJQh9',
  },
  deleteHeader: {
    description: 'Ship From delete modal header',
    defaultMessage: 'Delete Tax Identifier',
    id: 'LnEhb4',
  },
  iorLabel: {
    description: 'Importer of Record label for international settings page',
    defaultMessage: 'Importer of Record',
    id: 'DLt1Ez',
  },
  addIOR: {
    description: 'Add Importer of Record button in IOR section',
    defaultMessage: 'Add Importer of Record',
    id: 'Eud5+T',
  },
  addIORModalTitle: {
    description: 'Add Importer of Record modal title',
    defaultMessage: 'Importer of Record',
    id: 'yWmLaT',
  },
  addIORSubtext: {
    description: 'Add Importer of Record subtext for IOR section',
    defaultMessage: 'Add IOR data such as Name and IOR address.',
    id: 'KxsNcy',
  },
  cancelAddIOR: {
    description: 'Cancel button for Add Importer of Record modal',
    defaultMessage: 'Cancel',
    id: '+b4YQu',
  },
  iorNameField: {
    description: 'Importer of Record name field',
    defaultMessage: 'IOR Name',
    id: 'W7VIg2',
  },
  iorAddressField: {
    description: 'Importer of Record address field',
    defaultMessage: 'IOR Address',
    id: 'JJElP3',
  },
  deleteIORModalHeader: {
    description: 'Delete Importer of Record modal header',
    defaultMessage: 'Delete Importer of Record',
    id: 'Anp/lq',
  },
  confirmIORDeleteMessage: {
    description: 'Delete Importer of Record confirmation message',
    defaultMessage: 'Are you sure you want to delete this Importer of Record?',
    id: 'ZUqW7/',
  },
  confirmMessage: {
    description: 'Ship From delete modal text',
    defaultMessage: 'Are you sure you want to delete this Tax Identifier?',
    id: '0zpkB5',
  },
  cancel: {
    description: 'Cancel button',
    defaultMessage: 'Cancel',
    id: 'qz9XeG',
  },
  uniqueNickname: {
    description: 'Nickname must be unique error message',
    defaultMessage: 'Nickname must be unique',
    id: 'hxiNwM',
  },
  addError: {
    description: 'Unknown error occurred while adding tax identifier',
    defaultMessage: 'An unknown error has occurred while trying to save your tax identifier. Please try again.',
    id: 'z73M1a',
  },
  iTNOrUSPS: {
    description: 'AES dropdown message',
    defaultMessage: 'Would you like to use your ITN or <a>USPS Exemption Code for AES?</a>',
    id: '7/qCTb',
  },
  billDutiesAndTaxesToPayor: {
    description: 'International settings Duties & Taxes subheader',
    defaultMessage: 'Duties & Taxes',
    id: 'h14D68',
  },
  billDutiesAndTaxesToPayorDescription: {
    description: 'International settings Duties & Taxes description',
    defaultMessage: 'Enable to pay a guaranteed amount for duties, taxes, and fees at the time of label purchase.',
    id: '+ikr0u',
  },
  companyMinLengthError: {
    description: 'Company name minimum length error message',
    defaultMessage: 'Company must be at least 2 characters',
    id: 'HyknXA',
  },
});

export default messages;
